module.exports = __webpack_public_path__ + "static/Barlow-Medium-b83525e14ab37a2476a7c2e8f6479787.woff2";